<script setup>
import CustomerAuditForm from '@frontJs/components/forms/projectManagement/sem/CustomerAuditForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, websiteVariants, users, customerAudit } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    websiteVariants: {
        type: Array,
        required: true,
    },
    users: {
        type: Array,
        required: true,
    },
    customerAudit: {
        type: [Object, null],
        required: false,
        default: null,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="customerAudit">
            Mettre à jour l'audit client #{{ customerAudit.id }} - SEM - Gestion
            de projet - Datakepler
        </title>

        <title v-else>
            Créer un audit client - SEM - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="customerAudit" :tenant-name="tenant.name">
        Gestion de projet - SEM - Mettre à jour l'audit client #{{
            customerAudit.id
        }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - SEM - Créer un audit client
    </PageTitle>

    <CustomerAuditForm
        :tenant="tenant"
        :website-variants="websiteVariants"
        :users="users"
        :customer-audit="customerAudit"
    />
</template>
